module.exports = __webpack_public_path__ + "img/recordfail.c931af99.png";